import type { Dayjs } from 'dayjs';

export type CompanyBalancePeriod = 'MONTH' | 'QUARTER' | 'HALF_YEAR' | 'YEAR';

export interface CompanyBalanceRange {
  from: string;
  to: string;
  start: Dayjs;
  end: Dayjs;
}

export function resolveCompanyBalanceRange(
  anchor: Dayjs,
  period: CompanyBalancePeriod,
): CompanyBalanceRange {
  let start = anchor.startOf('month');
  let end = anchor.endOf('month');

  if (period === 'QUARTER') {
    const quarterStartMonth = Math.floor(anchor.month() / 3) * 3;
    start = anchor.month(quarterStartMonth).startOf('month');
    end = start.add(2, 'month').endOf('month');
  } else if (period === 'HALF_YEAR') {
    start = anchor.month(anchor.month() < 6 ? 0 : 6).startOf('month');
    end = start.add(5, 'month').endOf('month');
  } else if (period === 'YEAR') {
    start = anchor.startOf('year');
    end = anchor.endOf('year');
  }

  return {
    from: start.format('YYYY-MM'),
    to: end.format('YYYY-MM'),
    start,
    end,
  };
}
